<div [formGroup]="listForm">
    <div *ngIf="showZoningCodeSettings">
        <mat-card-content>Calculation results will be automatically added to the Zoning Code which is applicable for
            calculation.</mat-card-content>
        <div class="settings">
            <mat-form-field>
                <mat-select placeholder="Zoning code" formControlName="zoningCode" [disabled]="isPlaceSet || null"
                    (selectionChange)="setupZCPlaceId($event)">
                    <mat-option *ngFor="let zoningCode of zoningCodes" [value]="zoningCode">
                        {{zoningCode.Name}}
                    </mat-option>
                </mat-select>
                <mat-hint>ZC is for searching for a place, not for linking the results</mat-hint>
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="Place Id" formControlName="place">
            </mat-form-field>
        </div>
    </div>

    <div class="settingsWrap">
        <mat-radio-group formControlName="type" [required]="true" class="list-form">
            <mat-radio-button [value]="listType.FOLIOS">List of Folios (50 000 items maximum)</mat-radio-button>
            <br>
            <mat-radio-button [value]="listType.GRIDICS_IDS">List of Gridcs Ids (10 000 items
                maximum)</mat-radio-button>
            <br *ngIf="getUseGroupId">
            <mat-radio-button *ngIf="getUseGroupId" [value]="listType.GROUP_IDS">List of Group Ids (45 000 items
                maximum)
            </mat-radio-button>
        </mat-radio-group>
        <div *ngIf="showLayers">
            <div class="layers" formGroupName="layers">
                <span>Data source(s) to calculate:</span>
                <mat-checkbox formControlName="city" [disabled]="!disableLayers">City</mat-checkbox>
                <mat-checkbox formControlName="county" [disabled]="!disableLayers">County</mat-checkbox>
                <mat-checkbox formControlName="state" [disabled]="!disableLayers">State</mat-checkbox>
            </div>
            <mat-hint>Data source(s) will be ignore when calculation by Gridics Ids or Group Ids</mat-hint>
        </div>

    </div>


    <br>

    <mat-form-field>
        <textarea [required]="isPRListRequired" formControlName="list" matInput
            placeholder="List of folios of Gridcs Ids..." matTextareaAutosize matAutosizeMinRows=10
            matAutosizeMaxRows=15></textarea>
        <mat-error *ngIf="listForm.get('list').errors?.maxItems">
            Exceeded the maximum number of Folios / GridicsIds!
        </mat-error>
    </mat-form-field>

    <br>

    <mat-card-content>OR</mat-card-content>

    <br>

    <div class="file-chooser">
        <div class="file-name">
            <mat-form-field>
                <input matInput disabled="true" [value]="listForm.controls.file.value.name">
            </mat-form-field>
            <button mat-icon-button *ngIf="!isDefaultFile" (click)="setupEmptyFile()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div>
            <button type="button" color="accent" mat-raised-button (click)="fileInput.click()">
                <mat-icon>attach_file</mat-icon>
                Choose a file
            </button>
            <input hidden type="file" #fileInput (change)="uploadFile($event)" accept=".csv" />
        </div>
    </div>

    <div>
        <span>Threads Count</span><br>
        <mat-slider thumbLabel [displayWith]="safeValue" tickInterval="1" [min]="1"
            [max]="processService.availableThreadsCountValidated || 1" class="long-width-slider" showTickMarks>
            <input matSliderThumb formControlName="maxThreadsCount">
        </mat-slider>
        <span>{{maxThreadsCount}}</span>
    </div>

    <div *ngIf="forcedModeEnabled">
        <mat-checkbox formControlName="needToRecalculate" matTooltip="Override previous calculation results"
            matTooltipPosition="above" (change)="onNeedToRecalculateChange($event)">Forced mode</mat-checkbox>
    </div>
</div>